import React from 'react';

import Image from '../../../../library/image/image';

import styles from './studded-image.scss';

function StuddedImage() {
  return (
    <Image
      alt="Studded"
      className={styles['studded-image']}
      height="24"
      src="https://discounttire.scene7.com/is/content/discounttire/logos/icons/feature-icon_studded-tire.svg"
      width="24"
    />
  );
}

export default StuddedImage;
